import React, {Component} from 'react';
import RichTextEditor, {createEmptyValue} from 'react-rte';

const noToolbarDisplay = {
  display: [],
};

class TextEditor extends Component {
  constructor() {
    super();
    this.state = {
      content: createEmptyValue(),
    };
  }

  _onContentChange(content) {
    this.setState({
      content: content,
    });
  }

  componentDidMount() {}

  render() {
    return (
      <div className="text-editor">
        <RichTextEditor
          value={this.state.content}
          toolbarConfig={noToolbarDisplay}
          onChange={this._onContentChange.bind(this)}
        />
      </div>
    );
  }
}

export default TextEditor;
